import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hp-steps',
  templateUrl: './hyper-steps.component.html',
  styleUrls: ['./hyper-steps.component.css']
})
export class HyperStepsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
